import React from 'react';

const Events = () => {
    return (
        <div className="services">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="section-heading" style={{ fontSize: '32px', fontWeight: 'bold' }}>
                            <h2>Our <em>Events & Activities</em></h2>
                            <span>Join us in various technical and community events designed to <em>enhance your skills and network</em></span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-item" style={{ marginBottom: '20px' }}>
                            <img src="assets/images/workshop.jpg" alt="Technical Workshops" /> 
                            <div className="down-content">
                                <h4>Technical Workshops</h4>
                                <p>Hands-on training sessions covering cutting-edge technologies like Flutter, mobile development, web development, and more. Learn from industry experts and enhance your practical skills in a collaborative environment.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-item" style={{ marginBottom: '20px' }}>
                            <img src="assets/images/landIt.jpg" alt="Competitions" width="500" height="340" />
                            <div className="down-content">
                                <h4>Coding Competitions</h4>
                                <p>Challenge yourself in events and competitions. Test your problem-solving skills, compete with peers, and win exciting prizes while building your coding expertise.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-item" style={{ marginBottom: '20px' }}>
                            <img src="assets/images/lamma.jpg" alt="Community Service" />
                            <div className="down-content">
                                <h4>Community Service</h4>
                                <p>Make a positive impact through initiatives like organizing iftar for children at Dar Maram during Ramadan. We believe in using our tech skills to give back to society and build meaningful connections.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="service-item" style={{ marginBottom: '20px' }}>
                            <img src="assets/images/play.jpg" alt="Networking Events" />
                            <div className="down-content">
                                <h4>Networking Events</h4>
                                <p>Connect with fellow students, alumni, and industry professionals. Build lasting relationships, share experiences, and discover new opportunities in the tech industry through our regular networking sessions.</p>                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Events;